import { responseUtils } from '../utils';

export const faqServices = {
    getFaq
}

function getFaq(intl) {
    const opts = {
        method: 'GET'
    };

    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/faq`, opts)
        .then(
            res => responseUtils.handleResponse(res, intl),
            error => responseUtils.handleError(error, intl)
        );
}